// #region Constantes / Mock (persistência em localStorage)
const LS_KEY = 'configuracoes.app.v1';

// Valores padrão (espelham os campos exibidos na UI)
const defaultConfig = {
  // Salão
  nome_salao: 'Beauty Salon',
  cnpj: '00.000.000/0001-00',
  telefone: '(11) 99999-9999',
  endereco: 'Rua das Flores, 123 - Centro',
  seg_sex_inicio: '08:00',
  seg_sex_fim: '18:00',
  sabado_inicio: '08:00',
  sabado_fim: '16:00',
  funciona_domingo: false,
  almoco_inicio: '12:00',
  almoco_fim: '13:00',

  // Vendas / Caixa / Fiado
  mp_dinheiro: true,
  mp_cartao_debito: true,
  mp_cartao_credito: true,
  mp_pix: true,
  mp_fiado: true,
  caixa_valor_inicial_padrao: 100,
  caixa_fechamento_automatico: true,
  caixa_limite_sangria: 500,
  fiado_limite_maximo: 200,
  fiado_prazo_padrao_dias: 30,
  fiado_desconto_maximo: 15,

  // Sistema / Estoque / Aparência / Segurança
  estoque_minimo_global: 5,
  alerta_vencimento_dias: 30,
  controle_lotes: false,
  tema: 'SISTEMA', // SISTEMA | CLARO | ESCURO
  cor_principal: 'PINK', // PINK | LIGHT | YELLOW
  bloquear_inatividade: false,
  tempo_bloqueio_min: 15,

  // Notificações
  notif_estoque_baixo: true,
  notif_produtos_vencendo: true,
  notif_comissoes_pendentes: true,
  notif_fiados_vencidos: true,
  notif_backup_automatico: true,

  // Backup / Sistema
  backup_automatico_diario: true,
  ultimo_backup_info: 'Hoje às 03:00',
  versao_sistema: 'Beauty Manager v1.0.0',
  banco_dados: 'SQLite Local',
  ultima_sincronizacao: 'Agora',
};

function loadAll() {
  try {
    const raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (raw && typeof raw === 'object') return { ...defaultConfig, ...raw };
  } catch { /* ignore */ }
  return { ...defaultConfig };
}

function persist(cfg) {
  localStorage.setItem(LS_KEY, JSON.stringify(cfg));
}
// #endregion

// #region API (assíncrona simulada)
export async function getConfiguracoes() {
  return loadAll();
}

export async function saveConfiguracoes(patch) {
  const current = loadAll();
  const merged = { ...current, ...patch };
  persist(merged);
  return merged;
}

export async function resetConfiguracoes() {
  persist(defaultConfig);
  return { ...defaultConfig };
}

export async function limparDadosTeste() {
  // Remove chaves de mocks conhecidos (extensível futuramente)
  const KEYS = ['produtos.data.v1', 'mock.vendas.v1'];
  KEYS.forEach(k => localStorage.removeItem(k));
  return true;
}
// #endregion

// #region Export default (facilita import consolidado)
const configuracoesApi = {
  getConfiguracoes,
  saveConfiguracoes,
  resetConfiguracoes,
  limparDadosTeste,
  defaultConfig,
};
export default configuracoesApi;
// #endregion
